// src/slices/gstApiSlice.js
import { apiSlice } from './apiSlice';
import { INFORMATIONS_URL } from '../constants';

export const informationnApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // ✅ Get all GSTs
    getInformations: builder.query({
      query: () => ({
        url: INFORMATIONS_URL,
      }),
      providesTags: ['Information'],
      keepUnusedDataFor: 5,
    }),

    
    createInformation: builder.mutation({
      query: (data) => ({
        url: INFORMATIONS_URL,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Information'],
    }),

   
    // ✅ Delete GST (Soft Delete)
    deleteInformation: builder.mutation({
      query: (id) => ({
        url: `${INFORMATIONS_URL}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Informationn'],
    }),
  }),
});

export const {
  useGetInformationsQuery,
  useCreateInformationMutation,
  useDeleteInformationMutation,
} = informationnApiSlice;
